import { NgwKit, NgwWebmapItem } from '@nextgis/ngw-kit';

import { createScene3DAdapter } from './createScene3DAdapter';
import { createStyle3DAdapter } from './createStyle3DAdapter';
import { createTerrainProviderAdapter } from './createTerrainProviderAdapter';
import { getAdapterFromItemType } from './getAdapterFromItemType';

NgwKit.addClassAdapters('style_3d', createStyle3DAdapter);
NgwKit.addClassAdapters('scene_3d', createScene3DAdapter);
NgwKit.addClassAdapters('terrain_provider', createTerrainProviderAdapter);

NgwWebmapItem.GetAdapterFromLayerType['item'] = getAdapterFromItemType;
